<template>
	<div class="clip-list l-asport-one-panel-section -no-padding">
		<div class="clip-list__header">
			<Title
				:title="$I18n.trans('highlights.highlight_tool.clip_list.title')"
				:subtitle="$I18n.trans('highlights.highlight_tool.clip_list.subtitle')"
			/>
		</div>

		<ListView
			:items="selectedClips"
			:swipable="false"
			list-container-class="list-container"
			:list-body-class="['tbody']"
		>
			<template #no-results>
				{{ `&nbsp;` }}
			</template>
			<template #item-row="{ item }">
				<slot
					name="item-row"
					:entry="item"
				>
					<ClipListTile
						class="clip-list__item"
						:class="{ 'is-hovered': hoveredClipId === item.id }"
						:clip="item.tag"
						:event-id="eventId"
						:is-playing="item.id === currentClip?.id"
						:hide-share="true"
						:hide-rating="true"
						:hide-likes="true"
						:reduce-vertical-margin="false"
						:hide-context-menu="true"
						@play="$emit('play', item)"
						@mouseenter.native="$emit('clip-hover', item)"
						@mouseleave.native="$emit('clip-hover-end')"
					>
						<template #leading-placeholder>
							<div class="clip-list__index">
								{{ selectedClips.findIndex(clip => clip.id === item.id) + 1 }}
							</div>
						</template>
						<template #trailing>
							<div class="clip-list__actions">
								<Icon
									v-if="canEditEventTag(item.tag)"
									class="edit-icon"
									icon-name="pen"
									size="lg"
									@click.stop="$emit('edit', item)"
								/>
								<Icon
									class="remove-icon"
									icon-name="e-remove"
									size="lg"
									@click.stop="$emit('remove', item)"
								/>
							</div>
						</template>
					</ClipListTile>
				</slot>
			</template>
		</ListView>
	</div>
</template>

<script>
import ListView from '@components/lists/ListView';
import ClipListTile from '@components/clip-list/ClipListTile';
import Title from '@videotools/js/components/Title/Title';
import { mapGetters } from 'vuex';

export default {
	name:       'HighlightClipsList',
	components: {
		ClipListTile,
		ListView,
		Title,
	},
	props: {
		selectedClips: {
			type:     Array,
			required: true,
		},
		eventId: {
			type:     Number,
			required: true,
		},
		currentClip: {
			type:    Object,
			default: null,
		},
		hoveredClipId: {
			type:    Number,
			default: null,
		},
	},
	computed: {
		...mapGetters({
			canEditEventTag: 'permissions/canEditEventTag',
		}),
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.clip-list {
	flex: 1 1 auto;
	overflow: hidden;
}

.clip-list__header {
	flex-shrink: 0;
	padding: $sp4 var(--one-panel-h-padding) $sp4 var(--one-panel-h-padding);
}

.clip-list::v-deep .infinite-scroll-container {
	flex: 1 1 auto;
	min-height: 0;
}

.clip-list__index {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 39px;
	font-weight: 700;
	color: var(--color-grey-800);
	letter-spacing: -0.1em;
}

.clip-list__actions {
	display: flex;
	align-items: center;
	gap: $sp4;
	height: 100%;

	@media (hover: hover) {
		opacity: 0;
		transition: opacity $trans-time-fast;

		.clip-list__item:hover & {
			opacity: 1;
		}
	}

	@media (hover: none) {
		opacity: 1;
	}
}

.clip-list__item.is-hovered {
	background: var(--one-panel-background-color-row-hover);
}
</style>
